<template>
  <section class="flex statusMatchingRow">
    <div
      class="statusMatchingItem"
      v-for="(item, index) in statusMatchingItems"
      :key="index"
      :style="{ backgroundColor: item.bgColor }"
    >
      <figure class="image">
        <img :src="item.img" :alt="item.title" />
      </figure>
      <div class="itemText">
        <div style="display: flex; justify-content: center;">
          <div class="itemTextIcon">
            <figure>
              <img :src="item.icon" :alt="item.title" />
            </figure>
            <h6>{{ item.title }}</h6>
          </div>
        </div>
        <h6 class="itemTextDesc">
          {{ item.subTitle }}
        </h6>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "MatchingProcess",
  data() {
    return {
      statusMatchingItems: [
        {
          title: "프로필 작성",
          subTitle: "다른 기업들에게 보여질 소중한 기업정보를 입력해주세요.",
          img: "/images/myPage/matching1.svg",
          icon: "/images/myPage/docs.svg",
          bgColor: "#FFFDEE",
        },
        {
          title: "네트워킹 검색",
          subTitle: "다양한 시니어산업 기업 또는 관심 기업들을 찾아보세요.",
          img: "/images/myPage/matching2.svg",
          icon: "/images/myPage/search.svg",
          bgColor: "#FFFCDF",
        },
        {
          title: "네트워킹 매칭",
          subTitle:
            "직접 매칭 혹은 AgeTech Platform 자문을 통해 기업 매칭 진행.",
          img: "/images/myPage/matching3.svg",
          icon: "/images/myPage/chat.svg",
          bgColor: "#FFFACD",
        },
        {
          title: "네트워킹 진행",
          subTitle:
            "매칭이 이루어졌다면 상대 기업과 비즈니스 네트워킹을 해보세요.",
          img: "/images/myPage/matching4.svg",
          icon: "/images/myPage/hand.svg",
          bgColor: "#FFF499",
        },
      ],
    };
  },
};
</script>
